import {apiClientDT} from "@/state/modules/apiClientDT";
import {apiClient} from "@/state/modules/apiClient";
const controller = "AuthSync";
export const state = {
    currentUser: localStorage.getItem('congdan-token'),
    token:  localStorage.getItem('congdan-token')
}
export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.token = newValue
    },
}
export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        console.log("LOG : VÀO LOGGEDIN STORE !!! ",state);
        return !!state.currentUser
    }
}

export const actions = {
    async login({commit}, values) {
        return apiClientDT.post(controller +"/login", values);
    },
    async setCurrentUser({commit}, value){
        commit("SET_CURRENT_USER", value)
    },
    async register({commit}, values) {
        return apiClientDT.post(controller + "/register", values);
    },
    async updateCitizen({commit, dispatch}, values) {
        return apiClientDT.put(controller +"/change-profile", values);
    },
    async changePassword({commit}, params) {
        return apiClientDT.post(controller + "/change-password",params);
    },
    async verifyAccount({commit}, params) {
        return apiClientDT.post(controller + "/VerifyAccount",params);
    },
    async getByIdCongDan({commit}, id) {
        return apiClientDT.get(controller +"/get-user-by-id/" + id);
    },
    async getByUserNameCongDan({commit}, userName) {
        return apiClientDT.get(controller +"/get-user-by-username/" + userName);
    },
};
